export const POSITION = {
  topCenter: 'topCenter',
  bottomCenter: 'bottomCenter',
  topLeft: 'topLeft',
  topRight: 'topRight',
  bottomLeft: 'bottomLeft',
  bottomRight: 'bottomRight',
}
